// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/spend_management/memberships/bank_details/firstparty/v3/bank_details.proto

/* oxlint-disable */
import { ApiTimestamp } from "../../../../../../google/protobuf/timestamp";

/** Represents the bank details of a membership. */
export interface ApiMembershipBankDetails {
  /** The unique identifier of the membership bank details. */
  readonly id: string;
  /** The IBAN of the membership bank details. */
  readonly iban: string;
  /** The creation timestamp of the membership bank details. */
  readonly createdAt:
    | Date
    | null;
  /** The last update timestamp of the membership bank details. */
  readonly updatedAt?: Date | null | undefined;
}

export const ApiMembershipBankDetails: MessageFns<ApiMembershipBankDetails> = {
  fromJSON(object: any): ApiMembershipBankDetails {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      iban: isSet(object.iban) ? globalThis.String(object.iban) : "",
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : null,
      updatedAt: isSet(object.updatedAt) ? fromJsonTimestamp(object.updatedAt) : null,
    };
  },

  toJSON(message: ApiMembershipBankDetails): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.iban !== undefined && message.iban !== null) {
      obj.iban = message.iban;
    }
    if (message.createdAt !== undefined && message.createdAt !== null) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined && message.updatedAt !== null) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },
};

function fromTimestamp(t: ApiTimestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(ApiTimestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
